import { render, staticRenderFns } from "./BindingPhone.vue?vue&type=template&id=2a46fdad&scoped=true&"
import script from "./BindingPhone.vue?vue&type=script&lang=js&"
export * from "./BindingPhone.vue?vue&type=script&lang=js&"
import style0 from "./BindingPhone.vue?vue&type=style&index=0&id=2a46fdad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a46fdad",
  null
  
)

export default component.exports